import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body.animating {
    overflow: hidden;
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  *:focus {
    outline: none;
  }
  * h1,
  * h2,
  * h3,
  * h4,
  * h5,
  * h6 {
    margin: 0;
  }
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  a,
  area,
  button,
  input,
  label,
  select,
  textarea,
  [tabindex] {
    -ms-touch-action: manipulation;
    touch-action: manipulation;
  }

`;
